/**
 * Editorial-substance scale — shared label + badge styling for the manager UI.
 * Mirrors the backend EDITORIAL_SUBSTANCE_LABELS (prism.py). Widened to 1-5 for
 * the 2026-08-05 recalibration (v2): higher bands read as MORE prominent so the
 * badge hierarchy tracks materiality (a band-4/5 must never look neutral/low).
 * The pre-v2 corpus carries 1-3 only; those keys are unchanged.
 */
export const SUBSTANCE_LABEL: Record<number, string> = {
  1: 'procedural',
  2: 'light event',
  3: 'routine-material',
  4: 'notably material',
  5: 'exceptional',
};

/** Tailwind classes for the substance badge, graduated low → high. */
export function substanceBadgeClass(n: number | null | undefined): string {
  switch (n) {
    case 1: return 'bg-orange-50 text-orange-700';
    case 2: return 'bg-grey-100 text-grey-600';
    case 3: return 'bg-emerald-50 text-emerald-700';
    case 4: return 'bg-blue-50 text-blue-700';
    case 5: return 'bg-purple-50 text-purple-700';
    default: return 'bg-grey-100 text-grey-600';
  }
}
